import { render, staticRenderFns } from "./ModalNote.vue?vue&type=template&id=383b99e9&scoped=true&"
import script from "./ModalNote.vue?vue&type=script&lang=js&"
export * from "./ModalNote.vue?vue&type=script&lang=js&"
import style0 from "./ModalNote.vue?vue&type=style&index=0&id=383b99e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383b99e9",
  null
  
)

export default component.exports